export default "__VITE_ASSET__Djz_qiMT__"